import React from "react";
import SEO from "../components/SEO";
import HeroSection from "../components/home/HeroSection";
import ValuesSection from "../components/home/ValuesSection";
import FeaturedServicesSection from "../components/home/FeaturedServicesSection";
import HomeCTASection from "../components/home/HomeCTASection";
import { useSiteHero } from "../hooks/useSiteContent";

const Home = () => {
  const hero = useSiteHero();

  return (
    <div data-testid="home-page">
      <SEO
        path="/"
        description="CM Lindley - trusted supplier for builders & general contractors nationwide. Premium lumber, structural steel, engineered wood, trusses, and on-time job-site delivery."
      />
      <HeroSection hero={hero || {}} />
      <ValuesSection />
      <FeaturedServicesSection />
      <HomeCTASection />
    </div>
  );
};

export default Home;
